// src/components/GlobalHeader.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../../context/NotificationsContext";
import eventsIcon from "../../../assets/icons/CalendarIcon.png";
import personIcon from "../../../assets/icons/PersonIcon.png";
import coffeeIcon from '../../../assets/icons/CoffeeCup.png';
import settingsIcon from '../../../assets/icons/settings.png';
import communityIcon from '../../../assets/icons/friends.png';

import './index.css';

// If your API is same-origin on Vercel, empty string is fine
const API_BASE = "https://api-2026.fikacreatives.co";

export default function GlobalHeader({

    rightContent = null,
}) {
    const [loading, setLoading] = useState(false);
    const { availabilityPending } = useNotifications();
    const navigate = useNavigate();

    const goToProfile = () => navigate("/profile");
    const goToEvents = () => navigate("/events");
    const goToSettings = () => navigate("/settings");
    const goToFikas = () => navigate("/fikas");
    const goToFeatured = () => navigate("/featured");

    const onLogout = async () => {
        if (loading) return;
        setLoading(true);

        try {
            await fetch(`${API_BASE}/api/logout`, {
                method: "POST",
                credentials: "include",
            });
        } finally {
            window.location.replace("/sign-in");
        }
    };

    return (
        <header className="applyHeader">
            <div className="applyHeader__inner">
                <img className="applyLogo" src={"https://vdbpbpjwtbcyhnnwynox.supabase.co/storage/v1/object/sign/landing%20page/blue%20logo.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZGI0MGU3NC04Nzk2LTRhZmItOTViNy0wNDQ5YzAyNWMzZjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJsYW5kaW5nIHBhZ2UvYmx1ZSBsb2dvLnBuZyIsImlhdCI6MTc3NjY0Mjk2NywiZXhwIjoxODA4MTc4OTY3fQ.tVKPI3UsmTpjOTuowhPgS4KbsP7EVw9Jc9NQnYZ_M7Y"} alt="Fika" style={{ width: '80px' }} />

                <div className="globalHeader__right">

                    {/* <CoffeeStampCard
                        brand="fika"
                        showStampCard={true}
                        totalCups={10}
                    /> */}

                    <div style={{ position: "relative", marginRight: "16px", display: "inline-flex" }}>
                        <img
                            className="icon"
                            style={{ width: '24px' }}
                            onClick={goToFikas}
                            src={coffeeIcon}
                            alt="coffee"
                        />
                        {availabilityPending && (
                            <span style={{
                                position: "absolute",
                                top: -4,
                                right: -4,
                                width: 16,
                                height: 16,
                                borderRadius: "50%",
                                background: "#e53e3e",
                                color: "#fff",
                                fontSize: 10,
                                fontWeight: 700,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                pointerEvents: "none",
                            }}>
                                1
                            </span>
                        )}
                    </div>
                    {rightContent}

                    <img
                        className="icon"
                        style={{ width: '24px' }}
                        onClick={goToEvents}
                        src={eventsIcon}
                        alt="events"
                    />

                    <img
                        className="icon"
                        style={{ width: '30px', marginLeft: '16px' }}
                        onClick={goToFeatured}
                        src={communityIcon}
                        alt="featured members"
                    />


                    <img
                        className="icon"
                        style={{ width: '24px', marginLeft: '16px' }}
                        onClick={goToSettings}
                        src={settingsIcon}
                        alt="settings"
                    />

                    <img
                        className="icon"
                        style={{ width: '24px', marginLeft: '16px' }}
                        onClick={goToProfile}
                        src={personIcon}
                        alt="profile"
                    />



                    <button
                        className="applyVerifyTertiaryBtn"
                        onClick={onLogout}
                        style={{ marginLeft: '16px' }}
                    >
                        {loading ? "Signing out..." : "Sign out"}
                    </button>
                </div>
            </div>
        </header>
    );
}